import { getApiUrl, tokenInterceptor } from '@app/api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const projectsApi = createApi({
  reducerPath: 'projectApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/projects'),
    prepareHeaders: tokenInterceptor,
  }),
  endpoints: (builder) => ({
    getAllProjects: builder.query({
      query: () => ({
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetAllProjectsQuery } = projectsApi;
